module.exports = __webpack_public_path__ + "media/images/pocstock-contribute-hero-banner-2-d47bd531587d4712a7069b054c45b3e4.jpg";